import {type ButtonVariant, buttonVariants} from "#/_packages/umbrella/types";


export function tryGetButtonVariant(value?: string | null): ButtonVariant {
	return buttonVariants.includes(value as ButtonVariant)
		? (value as ButtonVariant)
		: "solid";
}

